import { schema } from 'normalizr'

const userSchema = new schema.Entity('users', {}, { idAttribute: 'userId' })
const professionalSchema = new schema.Entity('professionals', {}, { idAttribute: 'professionalId' })
const specialtySchema = new schema.Entity('specialties', {}, { idAttribute: 'agendaSpecialtyId' })
const officeSchema = new schema.Entity('offices', {}, { idAttribute: 'officeId' })
const insuranceSchema = new schema.Entity('insurances', {}, { idAttribute: 'agendaInsuranceId' })
const agendaSchema = new schema.Entity('agendas', {
  dtoProfessional: professionalSchema,
  dtoAgendaSpecialties: [specialtySchema],
  dtoOffice: officeSchema,
  dtoAgendaInsurances: [insuranceSchema],
})
const appointmentSchema = new schema.Entity('appointments', { /* bad json for office and professional */ }, { idAttribute: 'appointmentId' })
const reportSchemaCreator = (agendaId, year, month) => new schema.Entity('reports', {
  dtoProfessionalAppointments: [appointmentSchema],
}, { idAttribute: () => `${agendaId}_${year}_${month}` })

export { userSchema, agendaSchema, appointmentSchema, reportSchemaCreator }



// WEBPACK FOOTER //
// ./src/lib/schema.js